<template>
  <div class="footers wow animate__backInUp" data-wow-duration="1s">
    <div class="fooMwarp">
      <div class="cont1">
        <div class="title">联系我们</div>
        <ul>
          <li><span>全称：</span><span>九不欺</span></li>
          <li><span>邮编：</span><span>200433</span></li>
          <li><span>电话：</span><span>4000078989</span></li>
          <li><span>邮箱：</span><span>wangxinyi@lawxp.com</span></li>
        </ul>
      </div>
      <div class="cont2">
        <div class="title">友情链接</div>
        <ul>
          <li>
            <span
              ><a href="https://www.lawxp.com" target="_blank">汇法网</a></span
            >
            <span
              ><a href="https://www.lawxin.com/" target="_blank"
                >汇法风控宝</a
              ></span
            ><!--  // 汇法风控宝 -->
          </li>
          <li>
            <span
              ><a href="https://www.cuitx.cn" target="_blank">催天下</a></span
            >
            <span
              ><a href="https://www.fengxian110.com" target="_blank"
                >风险预警网</a
              ></span
            >
          </li>
          <li>
            <span
              ><a href="http://www.xiuerxin.com/" target="_blank"
                >修尔信</a
              ></span
            >
            <span
              ><a href="https://www.hhsqu.com" target="_blank"
                >合和社区</a
              ></span
            >
          </li>
          <li>
            <span
              ><a href="http://www.xinfushenghuo.cn" target="_blank"
                >信富生活</a
              ></span
            >
          </li>
        </ul>
      </div>
      <div class="down">
        <div class="downEwm">
          <p>关注九不欺</p>
          <img src="@/assets/images/index/ewm.png" />
          <p>关注公众号</p>
        </div>
      </div>
    </div>

    <!-- <div class="footerM">
             <div class="fooMwarp">
                <div class="fcontent">
                    <div class="cont1">
                         <div class="title">联系我们</div>
                         <ul>
                             <li><span>全称：</span><span>九不欺</span></li>
                             <li><span>邮编：</span><span>200000</span></li>
                             <li><span>电话：</span><span>4000078989</span></li>
                             <li><span>邮箱：</span><span>liyingbao@cuitx.cn</span></li>
                         </ul>
                    </div>
                    <div class="cont1 cont2">
                         <div class="title">友情链接</div>
                         <ul>
                                <li>
                                    <span><a href="https://www.lawxp.com" target="_blank">汇法网</a></span>
                                    <span><a href="https://www.lawxin.com/" target="_blank">风险信息网</a></span>
                                </li>
                                <li>
                                    <span><a href="https://www.cuitx.cn" target="_blank">催天下</a></span>
                                    <span><a href="https://www.fengxian110.com" target="_blank">风险预警网</a></span>
                                </li>
                                <li>
                                    <span><a href="http://www.xiuerxin.com/" target="_blank">修尔信</a></span>
                                    <span><a href="https://www.hhsqu.com" target="_blank">合和社区</a></span>
                                </li>
                                <li>
                                    <span><a href="http://www.xinfushenghuo.cn" target="_blank">信富生活</a></span>
                                </li>
                         </ul>
                    </div>
                </div>
                <div class="down">
                    <div class="downEwm">
                        <p>关注九不欺</p>
                           <img src="@/assets/images/index/ewm.png"/>
                        <p>关注公众号</p>
                    </div>
                </div>
                
             </div>
         </div> -->
    <div class="footerB">
      <div class="foowarp">
        <p>
          <a target="_blank" href="https://beian.miit.gov.cn">
            ICP备案号:沪ICP备2020033094号-7
          </a>
          <span class="rights_">经营许可证编号：沪B2-20211583 </span>
          <span class="rights_"
            >Copyright(C) 2021 上海汇法正信信息科技有限公司 All Rights
            Reserved</span
          >
        </p>
        <p style="display: flex; justify-content: center; margin-top: 10px">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005872"
            style="display: flex; align-items: center"
            ><img src="../../assets/images/warn.png" style="width: 18px" />
            &nbsp;
            <p>沪公网安备 31011002005872号</p>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  name: "footers",
  mounted() {
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      });
      wow.init();
    });
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.footers {
  width: 100%;

  background: #2b2d2e;
  .fooMwarp {
    padding: 20px 20%;
    display: flex;
    justify-content: space-between;
    .title {
      color: #fff;
      font-size: 16px;
      margin-bottom: 20px;
    }

    ul {
      li {
        line-height: 32px;
        color: #cccccc;
        font-size: 14px;
        a {
          color: #cccccc;
        }
      }
    }

    .cont2 {
      // padding:20px ;
      width: 20%;
      ul {
        //  width: 52%;
        li {
          line-height: 32px;
          color: #cccccc;
          font-size: 14px;
          display: flex;
          span {
            width: 50%;
            display: block;
            text-align: left;
          }
        }
      }
    }
  }
  .down {
    .downEwm {
      //  width: 40%;
      img {
        width: 80%;
        margin: 0 auto;
        margin-top: 28px;
        margin-bottom: 12px;
      }
      p {
        text-align: center;
        font-size: 16px;
        color: #fff;
        &:last-child {
          font-size: 14px;
          color: #cccccc;
        }
      }
    }
  }
  /* .footerM {
    background: #2b2d2e;
    .fooMwarp {
      width: 65%;
      margin: 0 auto;
      padding: 40px 0;
      display: flex;
      justify-content: space-around;
      .fcontent {
        width: 64%;
        display: flex;
        justify-content: space-around;
        .cont1 {
          width: 39%;
          border-right: 1px solid #666666;
          .title {
            color: #fff;
            font-size: 16px;
            margin-bottom: 34px;
          }
          ul {
            li {
              line-height: 32px;
              color: #cccccc;
              font-size: 14px;
              a {
                color: #cccccc;
              }
            }
          }
        }
        .cont2 {
          width: 47%;
          ul {
            width: 52%;
            li {
              display: flex;
              span {
                width: 50%;
                display: block;
                text-align: left;
              }
            }
          }
        }
      }
      .down {
        display: flex;
        align-items: center;
        width: 27%;
        justify-content: center;
        .downEwm {
          width: 40%;
          img {
            width: 80%;
            margin: 0 auto;
            margin-top: 28px;
            margin-bottom: 12px;
          }
          p {
            text-align: center;
            font-size: 16px;
            color: #fff;
            &:last-child {
              font-size: 14px;
              color: #cccccc;
            }
          }
        }
        .downsele {
          width: 47%;
          .downitem {
            margin-bottom: 11px;
            border: 1px solid #ffffff;
            border-radius: 6px;
            font-size: 18px;
            color: #fff;
            width: 100%;
            text-align: center;
            display: flex;
            align-items: center;
            padding: 5px 0;
            box-sizing: border-box;
            cursor: pointer;
            img {
              width: 18%;
              margin-left: 11%;
              margin-right: 6%;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  } */
  .footerB {
    display: flex;
    justify-content: center;
    .rights_ {
      display: inline-block;
      margin-left: 20px;
    }
    background: #131414;
    padding: 21px 0;
    p {
      font-size: 14px;
      color: #cccccc;
      a {
        color: #cccccc;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue